import React, { useEffect, useState } from 'react'
import AdminLayout from '../UI/Layout/AdminLayout'
import DeleteModal from '../Dashboard/campaign/Rcs/DeleteModal';
import { NODE_HOST_URL, NODE_HOST_URL_v1 } from '../Dashboard/api/Api';
import Axios from '../../axios/Axios';
import Spining from '../UI/Spining/Spining';
import { IoLogoWhatsapp } from 'react-icons/io';
import { FaSms } from 'react-icons/fa';
import RcsImage from "../Dashboard/assets/img/rcs.svg-removebg-preview.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { userloginDetails } from '../Utils/AdminAuth';

const ScheduleCampaign = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const adminType = lStorage.user.isAdmin;
    const subAdminPermission = lStorage?.permission?.per_value

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({
        successShow: false,
        bgColor: "",
        errorMessage: ""
    });
    const [channel, setChannel] = useState('all');
    const [loadingBtn, setloadingBtn] = useState(false);
    const [scheduleReportList, setScheduleReportList] = useState([]);

    const channelHandler = (e) => {
        setChannel(e.target.value);
        setError({ successShow: false })
        setScheduleReportList([]);
    }

    useEffect(() => {
        GetScheduleData();
    }, [])

    const GetScheduleData = async () => {
        setLoading(true);
        setloadingBtn(true);
        if (adminType === "admin" || (adminType === "subadmin" && subAdminPermission.report.children.read)) {
            try {
                if (channel === "all") {
                    const requests = [
                        { method: "getWpSchedule", type: "whatsapp" },
                        { method: "getSmsSchedule", type: "sms" },
                        { method: "getRcsSchedule", type: "rcs" },
                    ].map(req =>
                        Axios.post(
                            `${NODE_HOST_URL_v1}/admin/AdminSchedule`,
                            { user_id: userId, method: req.method },
                            { headers: { Authorization: `Bearer ${userToken}`, "Content-Type": "application/json" } }
                        ).then(res => ({ ...res, campaignType: req.type }))
                    );

                    const responses = await Promise.all(requests);

                    let combinedData = [];
                    responses.forEach(res => {
                        if (res.data.success) {
                            // add campaign_type to each record
                            const taggedData = res.data.data.map(item => ({
                                ...item,
                                campaign_type: res.campaignType,
                            }));
                            combinedData = [...combinedData, ...taggedData];
                        }
                    });

                    setScheduleReportList(combinedData);
                } else {
                    // single channel case
                    let method =
                        channel === "whatsapp"
                            ? "getWpSchedule"
                            : channel === "sms"
                                ? "getSmsSchedule"
                                : "getRcsSchedule";

                    const { data } = await Axios.post(
                        `${NODE_HOST_URL_v1}/admin/AdminSchedule`,
                        { user_id: userId, method },
                        { headers: { Authorization: `Bearer ${userToken}`, "Content-Type": "application/json" } }
                    );

                    if (data.success) {
                        // tag data with the current channel
                        const taggedData = data.data.map(item => ({
                            ...item,
                            campaign_type: channel,
                        }));
                        setScheduleReportList(taggedData);
                    } else {
                        setError({
                            successShow: true,
                            bgColor: "alert alert-danger",
                            errorMessage: data.message,
                        });
                    }
                }
            } catch (error) {
                setError({
                    successShow: true,
                    bgColor: "alert alert-danger",
                    errorMessage: error.response?.message || "Something went wrong",
                });
            } finally {
                setLoading(false);
                setloadingBtn(false);
            }
        }
    };

    return (
        <AdminLayout>
            <main className="content">
                <div className="container-fluid p-0">
                    <div className="row mb-2 mb-xl-3">
                        <div className="col-auto d-none d-sm-block">
                            <h3>
                                <strong>Schedule Campaign </strong>{" "}
                            </h3>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-12 col-xxl-5 d-flex">
                            <div className="w-100">

                            </div>
                        </div>
                    </div>

                    {error.successShow ? (
                        <div className={error.bgColor} role="alert">
                            <button
                                type="button"
                                className="close"
                                data-dismiss="alert"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                            <div className="">{error.errorMessage}</div>
                        </div>
                    ) : null}

                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                            <div className="card flex-fill ">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-3">
                                            <label>Select channel</label>
                                            {/* <div className="input-group drop-down-icons mt-2"> */}
                                            <select value={channel} onChange={channelHandler} className="form-control">
                                                <option value="all">All</option>
                                                <option value="whatsapp">Whatsapp</option>
                                                <option value="sms">SMS</option>
                                                <option value="rcs">RCS</option>
                                            </select>
                                            {/* </div> */}
                                        </div>
                                        <div className="col-md-1">
                                            <label></label>
                                            {loadingBtn ? (
                                                <button className="btn btn-success float-right" type="button" disabled>
                                                    <span
                                                        className="spinner-border spinner-border-sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                    {/* <span className="sr-only">Loading...</span> */}
                                                </button>
                                            ) : (
                                                <button
                                                    className="btn btn-success float-right"
                                                    onClick={GetScheduleData}
                                                >
                                                    <FontAwesomeIcon className="fa-lg" icon={faSearch} />
                                                </button>
                                            )}

                                        </div>
                                    </div>
                                </div>

                                {loading === true ? (
                                    <Spining />
                                ) : (
                                    <div className="col-md-12 mt-2">
                                        {scheduleReportList.length > 0 ? (
                                            <>
                                                {scheduleReportList?.map((item, i) => (
                                                    <div className="card" key={i}>
                                                        <div className="card-body">
                                                            <div className="d-flex justify-content-between campaign-flex-wrap align-items-center">
                                                                {/* Left side content */}
                                                                <p className="mb-0 d-flex align-items-center">
                                                                    {((channel === "whatsapp" || channel === "all") && item.campaign_type === "whatsapp") &&
                                                                        <IoLogoWhatsapp className="text-success mr-2" style={{ fontSize: '2em' }} />
                                                                    }

                                                                    {((channel === "sms" || channel === "all") && item.campaign_type === "sms") &&
                                                                        <FaSms className="text-primary mr-2" style={{ fontSize: '2em' }} />
                                                                    }

                                                                    {((channel === "rcs" || channel === "all") && item.campaign_type === "rcs") &&
                                                                        <img
                                                                            alt="Rcs Image"
                                                                            className="text-primary mr-2 rcs-logo-image"
                                                                            style={{ fontSize: '2em', width: '30px', height: '30px' }}
                                                                            src={RcsImage}
                                                                        />
                                                                    }

                                                                    <span>Campaign Name: </span>
                                                                    <span style={{ fontWeight: "bold" }}>
                                                                        {item.campaign_name}
                                                                    </span>
                                                                </p>

                                                                {/* Right side delete button */}
                                                                {/* <button
                                                                    className="btn btn-danger btn-sm mb-2"
                                                                    onClick={() => handleDelete(item.campaign_type === "rcs" ? item._id : item.id, item.campaign_type)}  // define handleDelete
                                                                >
                                                                    Delete
                                                                </button> */}
                                                                <span style={{ fontWeight: "bold" }}>
                                                                    {item.user_name}
                                                                </span>

                                                            </div>


                                                            <hr className="m-0 mb-1" />

                                                            <div className="row text-center">
                                                                <div className="col-6 col-md-2 mb-2">
                                                                    <span className="text-muted d-block">Campaign ID</span>
                                                                    <span className="fw-bold">
                                                                        {((channel === "rcs" || channel === "all") && item.campaign_type === "rcs")
                                                                            ? item._id
                                                                            : item.id}
                                                                    </span>
                                                                </div>

                                                                <div className="col-6 col-md-2 mb-2">
                                                                    <span className="text-muted d-block">Template ID</span>
                                                                    <span className="fw-bold">
                                                                        {((channel === "rcs" || channel === "all") && item.campaign_type === "rcs")
                                                                            ? item?.pannel_temp_id
                                                                            : item?.template_id}
                                                                    </span>
                                                                </div>

                                                                <div className="col-6 col-md-2 mb-2">
                                                                    <span className="text-muted d-block">Country Code</span>
                                                                    <span className="fw-bold">{item.country_code ? item.country_code : 91}</span>
                                                                </div>

                                                                <div className="col-6 col-md-2 mb-2">
                                                                    <span className="text-muted d-block">Total</span>
                                                                    <span className="fw-bold">{item.contact_count}</span>
                                                                </div>

                                                                <div className="col-6 col-md-2 mb-2">
                                                                    <span className="text-muted d-block">Schedule Time</span>
                                                                    <span className="fw-bold">{item.camp_start_datetime}</span>
                                                                </div>

                                                                <div className="col-6 col-md-2 mb-2">
                                                                    <span className="text-muted d-block">Created Date</span>
                                                                    <span className="fw-bold">{item.created_date}</span>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        ) :
                                            <div className="card d-flex justify-content-center align-items-center ">
                                                <h6 className="mt-2">No Record Found</h6>
                                            </div>}

                                    </div>
                                )}

                                {/* <DeleteModal show={deletePopup} onClose={CloseDeletePopup} onDelete={DeleteCampaign} /> */}

                                {/* <WhatsAppCampaignListPreview templateDetails={this.state.templateDetails} openTemplatePopup={this.state.openTemplatePopup} closePopup={this.closePopup} /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </AdminLayout>
    )
}

export default ScheduleCampaign
